import type { FeatureErrorMapper } from "@lib/errors/types";

/**
 * Images are unusual: most failures come from Supabase Storage, not Postgres,
 * so they arrive as messages rather than SQLSTATE codes. Matching on message is
 * the only signal available for the size/type cases (per docs/errors.md), and
 * they're the two a user can actually act on.
 */
export const imageErrorMapper: FeatureErrorMapper = (_action, err) => {
  const msg = err.message?.toLowerCase() ?? "";

  // Raised by the enforce_entity_image_limit trigger.
  if (msg.includes("entity_image_limit_reached")) {
    return "You can add up to 5 photos per item.";
  }

  if (
    msg.includes("maximum allowed size") ||
    msg.includes("payload too large") ||
    msg.includes("entity too large")
  ) {
    return "That image is too large — the limit is 10 MB.";
  }

  if (
    msg.includes("mime type") ||
    msg.includes("invalid_mime") ||
    msg.includes("not supported")
  ) {
    return "Unsupported file type. Use JPG, PNG, WEBP, or GIF.";
  }

  return null;
};
